import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function channelTimeConfigList(data) { return axios.post(`${base.url}/payment/payChannelTimeConfig/list`, qs.stringify(data)) }
export function channelTimeConfigDetail(id) { return axios.post(`${base.url}/payment/payChannelTimeConfig/detail`, qs.stringify({ id })) }
export function channelTimeConfigAddOrUpdate(data) { return axios.post(`${base.url}/payment/payChannelTimeConfig/addOrUpdate`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } }) }
export function channelTimeConfigDelete(id) { return axios.post(`${base.url}/payment/payChannelTimeConfig/deleteBatchIds`, qs.stringify({ ids: id })) }
export function channelTimeConfigStatus(id, status) { return axios.post(`${base.url}/payment/payChannelTimeConfig/status`, qs.stringify({ id, status })) }
